import InnerLayout from "../../layouts/inner-layout";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Layers, List, FileText, Settings, Pause, Globe, MapPin, Store } from "lucide-react";
import TreeView from "../../forms/treeView";
import { Play } from "lucide-react";
import SelectField from "../../forms/select-field";
import MinMaxSidePanel from "./sidePanel";
import { useEffect, useState } from "react";
import InventoryTable from "./inventory-table";
import { useDispatch } from "react-redux";
import { minMaxAddAction, minMaxGetAction, minMaxGetStoreListAction } from "../../../redux/actions/minMax-action";
import errorToast from "../../helper-components/error-toast";
import { convertToTreeFormat } from "../../forms/treeViewFomratConvertor";
import { itemTypeListAction } from "../../../redux/actions/general-action";
import successToast from "../../helper-components/success-toast";
import { itemGroupListAction } from "../../../redux/actions/general-action";
import { catListAction } from "../../../redux/actions/general-action";
import { isAdmin } from "../../../redux/config";
// const TREE_DATA = [
//   {
//     "module": "India",
//     "value":"COU001",
//     "data": [
//       {
//         "module": "South",
//         "value":"South01",
//         "data": [
//           {
//             "module": "Karntataka",
//             "value":"KA",
//             "data": [
//                 {
//                     "module": "Bengaluru",
//                     "value":"BA",
//                     "data": [
//                     {
//                         "module": "Bengaluru",
//                         "value":"BA",
//                         "data": [
//                             {
//                                 "module": "Whitefield",
//                                 "value":"WA",
//                                 "data": [
//                                     {
//                                         "module": "01K7RCQC6C7WGE23ZBRWH54RN6",
//                                         "value":"01K7RCQC6C7WGE23ZBRWH54RN6",
//                                         "data": []
//                                     }
//                                 ]
//                             }
//                         ]
//                     }
//                     ]
//                 }
//             ]
//           }
//         ]
//       }
//     ]
//   }
// ];

const MinMax = () => {
  // const [TREE_DATA,setTREE_DATA]=useState();
  // const [isRunning,setRunning]=useState(false);
  // const [shouldRender,setShouldRender]=useState(true);
  // const [data,setData]=useState();
  // const icons = [
  //   <Layers fill="#cf612c" stroke="#cf612c" />,
  //   <List fill="#cf612c" stroke="#cf612c" />,
  //   <FileText fill="#cf612c" stroke="#cf612c" />,
  // ];

  // const schema = Yup.object({
  //   selectedModules: Yup.array().min(1, "Please select at least one item"),
  // });

  // const [open, setOpen] = useState(false);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [itemType,setItemType]=useState(null);
  // const [itemGroup,setItemGroup]=useState(null);
  // const [itemData,setItemData]=useState();
  // const dispatch=useDispatch();
  // const onSuccess=(data)=>{
  //   const treeData=convertToTreeFormat(data.data);
  //   setTREE_DATA(treeData);
  // }
  // const onError=(data)=>{
  //   errorToast("unable to fetch stores");
  // }
  // const onItemTypeSuccess=(data)=>{
  //   const transformed={
  //     "name":"Category",
  //     "data":data?.data
  //   }
  //   const treeData=convertToTreeFormat(transformed);
  //   setItemType(treeData);
  // }
  // const onItemTypeError=(data)=>{
  //   errorToast("unable to fetch item types");
  // }
  // const onItemGroupSuccess=(data)=>{
  //   const transformed={
  //     "name":"Group",
  //     "data":data?.data
  //   }
  //   const treeData=convertToTreeFormat(transformed);
  //   setItemType(treeData);
  // }
  // const onItemGroupError=(data)=>{
  //   errorToast("unable to item groups");
  // }
  // useEffect(()=>{
  //   if(itemGroup && itemType){
  //     setItemData(itemType.append(itemGroup));
  //   }
  // },[itemType,itemGroup]);
  // useEffect(()=>{
  //   dispatch(
  //       minMaxGetStoreListAction(onSuccess,onError)
  //   )
  // },[]);
  // useEffect(()=>{
  //   dispatch(
  //     itemTypeListAction(onItemTypeSuccess,onItemTypeError)
  //   )
  // },[])
  // useEffect(()=>{
  //   dispatch(
  //     itemGroupListAction(onItemGroupSuccess,onItemGroupError)
  //   )
  // },[])
  // const onRunAnayalsisSuccess=(data)=>{
  //   if(shouldRender){
  //     console.log(data);
  //     setData(data?.data?.rows);
  //   }
  //   setShouldRender(true);
  //   setRunning(false);
  // };
  // const onRunAnayalsisError=(data)=>{
  //   setShouldRender(true);
  //   setRunning(false);
  //   errorToast("Unable to fetch min max");
  // };
  // function onClickRunanyalsis(values){
  //   if(isRunning){
  //     setShouldRender(false);
  //     setRunning(false);
  //   }else{
  //     setRunning(true);
  //     setShouldRender(true);
  //     if(values.selectedStores.length<1){
  //       errorToast("Please select atleast one store");
  //       setRunning(false);
  //       return;
  //     }
  //     const data={
  //       "demand_days":values.period,
  //       "min_days":values.minDays,
  //       "max_days":values.maxDays,
  //       "pos_ids":values.selectedStores.join(","),
  //       "pageNumber":currentPage,
  //       "pageSize":rowsPerPage
  //     }
  //     dispatch(
  //       minMaxGetAction(data,onRunAnayalsisSuccess,onRunAnayalsisError)
  //     );
  //   }
  // }
  // const onSubmitSuccess=(data)=>{
  //   successToast("Configured Min Max Successfully");
  // }
  // const onSubmitError=(data)=>{
  //   errorToast("Unable to configure min max");
  // }
  // function onFunctionSubmit(vaules){
  //   const result=vaules.inventoryValues.map(item => ({
  //       id: item.id,
  //       item_id: item.item_id,
  //       pos_id: item.pos_id,
  //       item_min_quantity: Number(item.suggested_min_qty),
  //       item_max_quantity: Number(item.suggested_max_qty)
  //   }));
  //   dispatch(
  //     minMaxAddAction(result,onSubmitSuccess,onSubmitError)
  //   )
  // }
  const dispatch = useDispatch();

  // Tree / Data States
  const [TREE_DATA, setTREE_DATA] = useState([]);
  const [itemType, setItemType] = useState([]);
  const [itemGroup, setItemGroup] = useState([]);
  const [itemCat, setItemCat] = useState([]);
  const [itemData, setItemData] = useState([]);
  const [data, setData] = useState([]);

  // UI / Control States
  const [isRunning, setRunning] = useState(false);
  const [shouldRender, setShouldRender] = useState(true);
  const [open, setOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // Icons
  const storeIcons = [
    <Globe fill="var(--primary)" stroke="#fff"/>,
    <MapPin fill="#4e904d" stroke="#fff"/>,
    <></>,
    <></>,
    <></>,
    <Store fill="#883ee1" stroke="#fff"/>,
    <Layers fill="#cf612c" stroke="#cf612c" />,
    <List fill="#cf612c" stroke="#cf612c" />,
    <FileText fill="#cf612c" stroke="#cf612c" />,
  ];
  const itemsIcons = [
    <Layers fill="#cf612c" stroke="#fff" />,
    <List fill="var(--primary)" stroke="var(--primary)" />,
    <FileText fill="#cf612c" stroke="#cf612c" />,
  ];


  // Form validation schema
  const schema = Yup.object({
    selectedModules: Yup.array().min(1, "Please select at least one item"),
  });

  // Merge itemType + itemGroup safely
  useEffect(() => {
    if (Array.isArray(itemType) && Array.isArray(itemGroup) && Array.isArray(itemCat)) {
      setItemData([...itemType, ...itemGroup,...itemCat]);
    }
  }, [itemType, itemGroup]);

  // Fetch initial data
  useEffect(() => {
    dispatch(minMaxGetStoreListAction(onSuccess, onError));
    dispatch(itemTypeListAction(onItemTypeSuccess, onItemTypeError));
    dispatch(itemGroupListAction(onItemGroupSuccess, onItemGroupError));
    dispatch(catListAction(onItemCatSuccess, onItemCatError));
  }, []);

  // Callbacks
  const onSuccess = (data) => {
    const treeData = convertToTreeFormat(data?.data || []);
    setTREE_DATA(treeData);
  };

  const onError = () => errorToast("Unable to fetch stores");

  const onItemTypeSuccess = (data) => {
    const transformed = { name: "Type", data: data?.data || [] };
    setItemType(convertToTreeFormat(transformed));
  };
  const onItemTypeError = () => errorToast("Unable to fetch item types");

  const onItemGroupSuccess = (data) => {
    const transformed = { name: "Group", data: data?.data || [] };
    setItemGroup(convertToTreeFormat(transformed));
  };
  const onItemGroupError = () => errorToast("Unable to fetch item groups");

  const onItemCatSuccess = (data) => {
    const transformed = { name: "Category", data: data?.data || [] };
    setItemCat(convertToTreeFormat(transformed));
  };
  const onItemCatError = () => errorToast("Unable to fetch item groups");

  const onRunAnaylsisSuccess = (res) => {
    setRunning(false);
    if (shouldRender) {
      setData(res?.data?.rows || []);
    }
    setShouldRender(true);
  };

  const onRunAnaylsisError = () => {
    setRunning(false);
    setShouldRender(true);
    errorToast("Unable to fetch min max");
  };

  const onClickRunanyalsis = (values) => {
    if (isRunning) {
      setRunning(false);
      setShouldRender(false);
      return;
    }

    if (!values.selectedStores || values.selectedStores.length < 1) {
      errorToast("Please select at least one store");
      return;
    }

    setRunning(true);
    setShouldRender(true);

    const payload = {
      demand_days: values?.period,
      min_days: values?.minDays,
      max_days: values?.maxDays,
      pos_ids: values?.selectedStores?.join(","),
      pageNumber: currentPage,
      pageSize: rowsPerPage,
      item_types: values?.selectedModules?.Type?.join(","),
      item_group: values?.selectedModules?.Group?.join(","),
      item_category: values?.selectedModules?.Category?.join(","),
    };
    dispatch(minMaxGetAction(payload, onRunAnaylsisSuccess, onRunAnaylsisError));
  };

  const onSubmitSuccess = () => successToast("Configured Min Max Successfully");
  const onSubmitError = () => errorToast("Unable to configure min max");

  const onFunctionSubmit = (values) => {
    if (!values.inventoryValues) return;

    const result = values.inventoryValues.map((item) => ({
      id: item.id,
      item_id: item.item_id,
      pos_id: item.pos_id,
      item_min_quantity: Number(item.suggested_min_qty),
      item_max_quantity: Number(item.suggested_max_qty),
    }));

    dispatch(minMaxAddAction(result, onSubmitSuccess, onSubmitError));
  };
  return (
    <InnerLayout backBtn={true} title="Min & Max">
      {isAdmin && <Formik
        initialValues={{ selectedModules: [],minDays:30,maxDays:30,period:"30" }}
        validationSchema={Yup.object({})}
        enableReinitialize={true}
        onSubmit={(values) =>{
          onFunctionSubmit(values);
        }
        }
      >
        {({ values, errors, touched,setFieldValue }) => (
          <Form className="max-w-full p-4 space-y-4 overflow-visible">
            <div className="flex justify-between items-center">
              <div className="gap-6">
                <div className="font-bold text-xxlg">
                  Dynamic Min-Max Inventory
                </div>
                <br />
                <div className="text-sm mt-2 text-[var(--description-color)]">
                  Optimize inventory levels based on historical sales data and
                  store performance
                </div>
              </div>
              <div>
                <button className={`flex items-center gap-2 border px-4 py-2 rounded-md hover:bg-[#EAF2FF] transition-all ${isRunning?"border-[#ff0000] text-[#ff0000]":"border-[#A4C6FF] text-[#377DFF]"}`}
                  onClick={(e)=>{
                    e.preventDefault();
                    onClickRunanyalsis(values);
                  }}
                >
                  {isRunning?<Pause fill="#ff0000" stroke="none" className="w-4 h-4"/>:<Play fill="#377DFF" stroke="none" className="w-4 h-4" />}
                  <span className="text-sm font-medium">{isRunning?"Cancel Analysis":"Run Analysis"}</span>
                </button>
              </div>
            </div>

            <div className="flex gap-2 h-[36vh] w-full">
              <div className="w-1/2 h-full border border-[var(--button-border-color)] rounded-md p-2 overflow-auto">
                <TreeView
                  name="selectedStores"
                  heading="Store"
                  data={TREE_DATA}
                  icons={storeIcons}
                  search={true}
                  searchPlaceholder="Search Store..."
                  sizes={{ text: "0.9rem", arrow: 18, icon: 16 }}
                  defaultExpandLevel={1}
                  classNames={{
                    node: "flex items-center gap-2 py-1 hover:bg-gray-100",
                    label: "text-[var(--description-color)] font-medium",
                    checkbox: "accent-[var(--primary)] text-[#fff]",
                    wrapper: "border-0 h-full",
                  }}
                />
              </div>

              <div className="w-1/2 h-full border border-[var(--button-border-color)] rounded-md p-2 overflow-auto">
                <TreeView
                  name="selectedModules"
                  heading="Item"
                  data={itemData}
                  icons={itemsIcons}
                  search={true}
                  searchPlaceholder="Search items..."
                  sizes={{ text: "0.9rem", arrow: 18, icon: 16 }}
                  defaultExpandLevel={1}
                  nameAfterParent={true}
                  classNames={{
                    node: "flex items-center gap-2 py-1 hover:bg-gray-100",
                    label: "text-[var(--description-color)] font-medium",
                    checkbox: "accent-[var(--primary)] text-[#fff]",
                    wrapper: "border-0 h-full",
                  }}
                />
              </div>
            </div>

            <div className="w-full flex justify-between flex-row items-center">
              <span className="text-lg font-bold">
                Inventory Items
                <span className="text-sm text-[var(--description-color)] font-normal ml-5">
                  Showing 20 of 485 items
                </span>
              </span>
              <div className="flex flex-row items-center">
                <span className="text-lg font-bold">
                  Demand Period Calculation
                </span>

                <div className="relative inline-block ml-3">
                  <Field
                    as="select"
                    name="period"
                    className="rounded-md ml-3 px-2 py-1 w-[180px] border border-[#d0d5dd] appearance-none focus:outline-none focus:ring-0 focus:ring-none"
                  >
                    <option value="30">30 Days</option>
                    <option value="60">60 Days</option>
                    <option value="120">120 Days</option>
                  </Field>
                  <svg
                    className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#667085] pointer-events-none"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>

                <button
                  className="ml-[4px] border border-[#d0d5dd] rounded-md p-[2px]"
                  onClick={() => {
                    setOpen(true);
                  }}
                  type="button"
                >
                  <Settings size={"20px"} stroke="#717179" />
                </button>

                <MinMaxSidePanel open={open} setOpen={setOpen} />
              </div>
            </div>

            <InventoryTable 
              data={data} 
              setFieldValue={setFieldValue}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              onClickRunanyalsis={onClickRunanyalsis}
            />
            <div className="flex justify-end items-center p-2 w-full">
                <button className="bg-primary text-white font-medium px-4 py-2 rounded" type="submit">
                    Apply All Changes
                </button>
            </div>

          </Form>
        )}
      </Formik>}
    </InnerLayout>
  );
};

export default MinMax;
